export enum AccessibilityType {
  LIVE_ATTENDANCE = 'LIVE_ATTENDANCE',
  STREAMING = 'STREAMING',
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/model/accessibility-type.ts